import BaseTelemetryService from "./BaseTelemetryService";

/**
 * Telemetry Service
 * Handles all telemetry tracking operations
 * Sends data to both legacy telemetry API and new API v2 for backward compatibility
 */
class TelemetryService extends BaseTelemetryService {
  /**
   * Post impressions data (bulk listing impressions)
   */
  async postImpressions(data: string, location: string): Promise<void> {
    await Promise.allSettled([
      // Legacy API call (commented out in v1, keeping for reference)
      // this.apiPost(`/t/i?d=${data}&p=${location}`),
      this.apiPostV2(`/telemetry/t/i?d=${data}&p=${location}`)
    ]);
  }

  /**
   * Post view tracking data
   */
  async postView(data: string, location: string): Promise<void> {
    await Promise.allSettled([
      // Legacy API call (commented out in v1, keeping for reference)
      // this.apiPost(`/t/v?d=${data}&p=${location}`),
      this.apiPostV2(`/telemetry/t/v`, { d: data, p: location })
    ]);
  }

  /**
   * Post engagement tracking data
   */
  async postEngagement(data: string, location: string): Promise<void> {
    await Promise.allSettled([
      // Legacy API call (commented out in v1, keeping for reference)
      // this.apiPost(`/t/e?d=${data}&p=${location}`),
      this.apiPostV2(`/telemetry/t/e`, { d: data, p: location })
    ]);
  }

  /**
   * Post search tracking data
   */
  async postSearch(data: any, location: string): Promise<void> {
    const payload = { ...data, location };
    await Promise.allSettled([
      // Legacy API call (commented out in v1, keeping for reference)
      // this.apiPost(`/t/s?p=${location}`, data),
      this.apiPostV2(`/telemetry/t/s`, payload)
    ]);
  }

  /**
   * Post the location suggestion a user clicked in the search-bar dropdown
   */
  async postSearchLocationClick(data: any): Promise<void> {
    await Promise.allSettled([this.apiPostV2(`/telemetry/t/lc`, data)]);
  }

  /**
   * Post quote request tracking data
   */
  async postQuoteRequestData(data: any): Promise<void> {
    await Promise.allSettled([
      // Legacy API call (commented out in v1, keeping for reference)
      // this.apiPost(`/t/q`, data),
      this.apiPostV2(`/telemetry/t/q`, data)
    ]);
  }
}

export default new TelemetryService();

